<template>
  <BModal
    id="modal-tall"
    :model-value="modal"
    scrollable
    centered
    size="lg"
    title="Payment"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Payment</h5>
        <!-- <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div
            class="bg-success rounded-circle"
            style="width: 10px; height: 10px"
          ></div>
          <span>online: Ruth</span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Guest Information">
        <BForm>
          <BRow>
            <BCol md="6">
              <div class="form-group">
                <label>ID/Passport</label>
                <p>{{ bill.guest.identity_number }}</p>
              </div>
            </BCol>
            <BCol md="6">
              <div class="form-group">
                <label>Name</label>
                <p>{{ bill.guest.alias }}. {{ bill.guest.fullname }}</p>
              </div>
            </BCol>
          </BRow>
          <BRow>
            <BCol md="6">
              <div class="form-group">
                <label>Room</label>
                <p>{{ bill.room.code }}</p>
              </div>
            </BCol>
            <BCol md="6">
              <div class="form-group">
                <label>Duration</label>
                <p>{{ bill.reservation.days }} night</p>
              </div>
            </BCol>
          </BRow>

          <!-- Loop Extra Charges -->
          <div class="d-flex justify-content-between align-items-center mb-1">
            <label class="mb-0 font-weight-bold">ExtraCharge</label>
          </div>
          <div class="table-responsive mb-3" style="overflow-x: auto; overflow-y: hidden;">
          <table class="table table-sm table-bordered mb-0" style="min-width: 600px;">
            <thead>
              <tr>
                <th class="text-left">Item Name</th>
                <th class="text-center" style="width: 80px;">Quantity</th>
                <th class="text-right" style="width: 120px;">Price</th>
                <th class="text-right" style="width: 130px;">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(charge, index) in bill.extra_charges" :key="index">
                <td class="text-left">{{ charge.name }}</td>
                <td class="text-center">{{ charge.quantity }}</td>
                <td class="text-right">{{ formatIDR(charge.price) }}</td>
                <td class="text-right">{{ formatIDR(charge.total ?? (charge.quantity * charge.price)) }}</td>
              </tr>
              <tr>
                <td class="text-right fw-bold" colspan="3">Total Extra Charge</td>
                <td class="text-right fw-bold">
                  {{
                    formatIDR(
                      (bill.extra_charges || []).reduce(
                        (sum, item) => sum + (Number(item.total) || (Number(item.quantity) * Number(item.price)) || 0),
                        0
                      )
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          </div>

          <label>Resto Bill</label>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Order</th>
                <th class="text-left">Status</th>
                <th class="text-left">Paid</th>
                <th class="text-left">Billed</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(restoBill, index) in bill.resto_bill" :key="index">
                <td class="text-left">
                  {{ dateFormatter(restoBill?.invoice_date) ?? "-" }}
                </td>
                <td class="text-left">
                  {{
                    restoBill.items.reduce(
                      (total, item) => total + item.quantity,
                      0
                    )
                  }}
                </td>
                <td class="text-left">
                  <span
                    class="badge text-capitalize"
                    :class="{
                      'bg-success': restoBill.status === 'PAID',
                      'bg-warning': restoBill.status !== 'PAID',
                    }"
                    >{{ restoBill.status }}</span
                  >
                </td>
                <td class="text-left">
                  {{
                    formatIDR(
                      restoBill.status === "PAID" ? restoBill.invoice_total : 0
                    )
                  }}
                </td>
                <td class="text-left">
                  {{ formatIDR(restoBill.sisa_tagihan) }}
                </td>
              </tr>
              <tr>
                <td class="text-end fw-bold" colspan="4">Total</td>
                <td class="text-left fw-bold">
                  {{ formatIDR(bill.grand_total_resto) }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Totals -->
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Grand Total Hotel:
              <b class="font-weight-bold">{{
                formatIDR(bill.grand_total_hotel)
              }}</b>
            </p>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Grand Total Resto:
              <b class="font-weight-bold">{{
                formatIDR(bill.grand_total_resto)
              }}</b>
            </p>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Grand Total:
              <b class="font-weight-bold">{{ formatIDR(bill.grand_total) }}</b>
            </p>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Total Paid:
              <b class="font-weight-bold">{{ formatIDR(bill.total_paid) }}</b>
            </p>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Remaining Bill:
              <b class="font-weight-bold">{{ formatIDR(bill.sisa_tagihan) }}</b>
            </p>
          </div>
        </BForm>
      </BTab>
      <BTab title="Payment">
        <div class="form-group">
          <BFormInput
            type="hidden"
            v-model="paymentForm.reservation_uuid"
            :value="uuid"
          />
          <BFormSelect v-model="paymentForm.payment_method_uuid" class="">
            <template #first>
              <BFormSelectOption :value="null" disabled>
                Select payment method
              </BFormSelectOption>
            </template>
            <BFormSelectOption
              v-for="method in paymentMethods"
              :key="method.uuid"
              :value="method.uuid"
            >
              {{ method.name }} {{ method.number }}
            </BFormSelectOption>
          </BFormSelect>
        </div>
        <div class="form-group">
          <label>Remaining Bill: {{ formatIDR(bill.sisa_tagihan) }}</label>
          <BFormInput
            type="number"
            v-model="paymentForm.amount"
            placeholder="nominal amount to be paid"
          >
          </BFormInput>
        </div>
        <div class="form-group">
          <label for="">Payment Date</label>
          <BFormInput type="date" v-model="paymentForm.payment_date">
          </BFormInput>
        </div>

        <div class="form-group">
          <BFormTextarea
            v-model="paymentForm.description"
            placeholder="Remarks(Optional)"
            rows="3"
          />
        </div>
      </BTab>
    </BTabs>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="payBill()"
          class="mr-2"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Pay" }}</BButton
        >
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { inject, ref, watch } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";

import {
  BRow,
  BCol,
  BForm,
  BModal,
  BTabs,
  BTab,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  // BInputGroup,
  BButton,
  // BListGroup,
  // BListGroupItem,
  BFormTextarea,
  // BFormRadioGroup,
} from "bootstrap-vue-next";
export default {
  props: {
    modal: Boolean,
    uuid: String,
  },
  name: "CheckInForm",
  components: {
    BRow,
    BCol,
    BForm,
    BTabs,
    BTab,
    BModal,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    //   BInputGroup,
    BButton,
    // BListGroup,
    // BListGroupItem,
    BFormTextarea,
    // BFormRadioGroup,
    ToastResponse,
  },

  emits: ["update:modal", "paid"],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const billRepository = repositories ? repositories.reservations : null;
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const isLoading = ref(false);

    const options = ref([
      {
        text: "Ya",
      },
      {
        text: "Tidak",
      },
    ]);

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const selectedPaymentMethod = ref(null);
    const paymentMethods = ref([]);

    const paymentForm = ref({
      reservation_uuid: props.uuid,
      payment_method_uuid: null,
      payment_type: "Payment",
      payment_date: null,
      amount: null,
      reference_number: null,
    });

    const bill = ref({
      reservation: {},
      guest: {},
      grand_total: 0,
      total_paid: 0,
      sisa_tagihan: 0,
      is_paid: false,
      room: [{}],
      payments: [{}],
      extra_charges: [{}],
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const getBill = async (uuid) => {
      try {
        const response = await billRepository.getBill(uuid);
        bill.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const resetForm = () => {
      paymentForm.value = {
        reservation_uuid: props.uuid,
        payment_method_uuid: null,
        payment_type: "Payment",
        payment_date: null,
        amount: null,
        reference_number: null,
      };
    };

    const payBill = async () => {
      try {
        isLoading.value = true;
        const response = await billRepository.payBill(paymentForm.value);
        modalResponse.value = {
          toast: true,
          text: response.data.message,
          success: true,
        };
        emit("paid");
        updateModal(false);
        resetForm();
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        modalResponse.value = {
          toast: true,
          text: error.response.data.message,
          success: false,
        };
      }
    };

    const getListPaymentMethod = () => {
      paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = [
            ...res.data.data.filter((i) => (i.status === "active" ? i : null)),
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    watch([() => props.modal, () => props.uuid], ([modalVal, uuidVal]) => {
      paymentForm.value.reservation_uuid = uuidVal;
      if (modalVal && uuidVal) {
        getBill(uuidVal);
        getListPaymentMethod();
      }
    });

    return {
      bill,
      getBill,
      payBill,
      getListPaymentMethod,
      billRepository,
      paymentMethodRepository,
      paymentForm,
      updateModal,
      dateFormatter,
      modalResponse,
      isLoading,
      paymentMethods,
      selectedPaymentMethod,
      options,
      formatIDR,
    };
  },
};
</script>

<style></style>
